(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types', 'emotion', 'recompose/onlyUpdateForKeys'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('emotion'), require('recompose/onlyUpdateForKeys'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.emotion, global.onlyUpdateForKeys);
    global.PacmanLoader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _emotion, _onlyUpdateForKeys) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  // This returns an animation
  var pacman = [(0, _emotion.keyframes)('0%{transform:rotate(0deg)}50%{transform:rotate(-44deg)}'), (0, _emotion.keyframes)('0%{transform:rotate(0deg)}50%{transform:rotate(44deg)}')];

  var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loader.__proto__ || Object.getPrototypeOf(Loader)).call.apply(_ref, [this].concat(args))), _this), _this.ball = function () {
        var _this$props = _this.props,
            size = _this$props.size,
            sizeUnit = _this$props.sizeUnit;


        return (0, _emotion.keyframes)('75%{opacity:0.7}100%{transform:translate(', '' + -4 * size + sizeUnit, ',', '' + -size / 4 + sizeUnit, ')}');
      }, _this.ballStyle = function (i) {
        var _this$props2 = _this.props,
            color = _this$props2.color,
            margin = _this$props2.margin,
            size = _this$props2.size,
            sizeUnit = _this$props2.sizeUnit;


        return (0, _emotion.css)('{width:', '' + size / 3 + sizeUnit, ';height:', '' + size / 3 + sizeUnit, ';background-color:', color, ';margin:', margin, ';border-radius:100%;transform:translate(0,', '' + -size / 4 + sizeUnit, ');position:absolute;top:', size, 'px;left:', '' + size * 4 + sizeUnit, ';animation:', _this.ball(), ' 1s ', i * 0.25, 's infinite linear;animation-fill-mode:both;}');
      }, _this.s1 = function () {
        var _this$props3 = _this.props,
            size = _this$props3.size,
            sizeUnit = _this$props3.sizeUnit;


        return '' + size + sizeUnit + ' solid transparent';
      }, _this.s2 = function () {
        var _this$props4 = _this.props,
            size = _this$props4.size,
            sizeUnit = _this$props4.sizeUnit,
            color = _this$props4.color;


        return '' + size + sizeUnit + ' solid ' + color;
      }, _this.pacmanStyle = function (i) {
        var _this$props5 = _this.props,
            size = _this$props5.size,
            sizeUnit = _this$props5.sizeUnit;


        var s1 = _this.s1();
        var s2 = _this.s2();

        return (0, _emotion.css)('{width:0;height:0;border-right:', s1, ';border-top:', i === 0 ? s1 : s2, ';border-left:', s2, ';border-bottom:', i === 0 ? s2 : s1, ';border-radius:', '' + size + sizeUnit, ';position:absolute;animation:', pacman[i], ' 0.8s infinite ease-in-out;animation-fill-mode:both;}');
      }, _this.wrapper = function () {
        var _this$props6 = _this.props,
            size = _this$props6.size,
            sizeUnit = _this$props6.sizeUnit,
            className = _this$props6.className;


        var wrapper = (0, _emotion.css)('{position:relative;font-size:0;height:', '' + size + sizeUnit, ';width:', '' + size + sizeUnit, ';}');

        return className ? (0, _emotion.css)(wrapper, ';', className) : wrapper;
      }, _this.pac = function () {
        return _this.pacmanStyle(0);
      }, _this.man = function () {
        return _this.pacmanStyle(1);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Loader, [{
      key: 'render',
      value: function render() {
        var loading = this.props.loading;


        return loading ? _react2.default.createElement(
          'div',
          { className: this.wrapper() },
          _react2.default.createElement('div', { className: this.pac() }),
          _react2.default.createElement('div', { className: this.man() }),
          _react2.default.createElement('div', { className: this.ballStyle(2) }),
          _react2.default.createElement('div', { className: this.ballStyle(3) }),
          _react2.default.createElement('div', { className: this.ballStyle(4) }),
          _react2.default.createElement('div', { className: this.ballStyle(5) })
        ) : null;
      }
    }]);

    return Loader;
  }(_react2.default.Component);

  Loader.propTypes = {
    loading: _propTypes2.default.bool,
    color: _propTypes2.default.string,
    size: _propTypes2.default.number,
    margin: _propTypes2.default.string,
    sizeUnit: _propTypes2.default.string,
    className: _propTypes2.default.string
  };

  Loader.defaultProps = {
    loading: true,
    color: '#000000',
    size: 25,
    margin: '2px',
    sizeUnit: 'px',
    className: ''
  };

  var Component = (0, _onlyUpdateForKeys2.default)(['loading', 'color', 'size', 'margin', 'sizeUnit', 'className'])(Loader);
  Component.defaultProps = Loader.defaultProps;
  exports.default = Component;
});


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/PacmanLoader.js
// module id = 2157
// module chunks = 0